function showBackground(lazyBackground: HTMLElement): void {
	lazyBackground.classList.remove("bm-lazy");
}

export function initLazyLoad(): void {
	const lazyBackgrounds: HTMLElement[] = Array.from(document.querySelectorAll(".bm-lazy"));

	if (lazyBackgrounds.length) {
		if ("IntersectionObserver" in window) {
			const lazyBackgroundObserver = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						const lazyBackground = entry.target as HTMLElement;
						showBackground(lazyBackground);
						lazyBackgroundObserver.unobserve(lazyBackground);
					}
				});
			});

			lazyBackgrounds.forEach((lazyBackground) => {
				lazyBackgroundObserver.observe(lazyBackground);
			});
		} else {
			lazyBackgrounds.forEach((lazyBackground) => {
				showBackground(lazyBackground);
			});
		}
	}
}

export function initNoLazyLoad(): void {
	Array.from(document.querySelectorAll(".bm-lazy")).forEach((element) => element.classList.remove("bm-lazy"));
}
